import { Checkbox, FormControlLabel, FormGroup, makeStyles, styled, Typography } from '@material-ui/core';
import React from 'react';
import { toCamelCase } from '../contests/utils';

const useStyle = makeStyles({
  label: {
    fontFamily: 'Lato',
    fontWeight: '500',
    fontSize: '12px',
  },
});

const CustomStyledCheckbox = styled(Checkbox)(({ theme }) => ({
  color: 'rgba(208, 213, 221, 1)',

  '&.Mui-checked': {
    color: 'rgba(98, 47, 238, 1)',
  },

  '&.Mui-disabled': {
    color: theme.palette.action.disabled,
  },

  '&.Mui-checked.Mui-disabled': {
    color: theme.palette.action.disabled,
  },
}));

const CustomGroupCheckbox = ({ handleChange, data, options, name, disabledOptions = [] }) => {
  const classes = useStyle();
  const selectedValues = data?.[name] || [];
  return (
    <FormGroup row>
      {options?.map((option) => (
        <FormControlLabel
          key={option.name}
          control={
            <CustomStyledCheckbox
              onChange={handleChange}
              name={name}
              value={option.name}
              disabled={disabledOptions.includes(option.name)}
              checked={selectedValues.includes(option.name)}
            />
          }
          label={<Typography className={classes.label}>{toCamelCase(option.name)}</Typography>}
        />
      ))}
    </FormGroup>
  );
};

export default React.memo(CustomGroupCheckbox);
